import React, { Component } from 'react';
import './OuterLocation.css';
import $ from 'jquery';

import { app } from '../../base';
import { Route } from 'react-router-dom';
import Success from '../Success/Success';


let marker;
let latLng;
let panorama = "";
let streetLat = "";
let streetLng = "";
let panoCoords = "";
let currentLat = "";
let currentLng = "";
let panoHeading = "";
let panoPitch = "";
let imageURL = "";
let inputAddress = "";

let db = app.database();
class OuterLocation extends Component {
    state = {
        pictureTaken: false,
        pointTaken: false
    }
    componentDidMount() {
        window.initialize = this.initialize;
    }

    initialize() {// Create the search box and link it to the UI element.
        if (navigator.geolocation) {
            let options = {
                enableHighAccuracy: true,
                maximumAge: 600000, timeout: 5000
            }
            navigator.geolocation.getCurrentPosition(position => {
                currentLat = position.coords.latitude;
                currentLng = position.coords.longitude;
                let map = new window.google.maps.Map(
                    document.getElementById("maps"), {
                    center: new window.google.maps.LatLng(currentLat, currentLng),
                    zoom: 13,
                    mapTypeId: window.google.maps.MapTypeId.ROADMAP
                });

                const input = document.getElementById("pac-input");
                const searchBox = new window.google.maps.places.SearchBox(input);
                map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);
                // Bias the SearchBox results towards current map's viewport.
                map.addListener("bounds_changed", () => {
                    searchBox.setBounds(map.getBounds());
                });
                let markers = [];
                // Listen for the event fired when the user selects a prediction and retrieve
                // more details for that place.
                searchBox.addListener("places_changed", () => {
                    const places = searchBox.getPlaces();

                    if (places.length === 0) {
                        return;
                    }
                    // Clear out the old markers.
                    markers.forEach((marker) => {
                        marker.setMap(null);
                    });
                    markers = [];
                    // For each place, get the icon, name and location.
                    const bounds = new window.google.maps.LatLngBounds();
                    places.forEach((place) => {
                        if (!place.geometry) {
                            console.log("Returned place contains no geometry");
                            return;
                        }
                        const icon = {
                            url: place.icon,
                            size: new window.google.maps.Size(71, 71),
                            origin: new window.google.maps.Point(0, 0),
                            anchor: new window.google.maps.Point(17, 34),
                            scaledSize: new window.google.maps.Size(25, 25),
                        };
                        // Create a marker for each place.
                        markers.push(
                            new window.google.maps.Marker({
                                map,
                                icon,
                                title: place.name,
                                position: place.geometry.location,
                            })
                        );

                        if (place.geometry.viewport) {
                            // Only geocodes have viewport.
                            bounds.union(place.geometry.viewport);
                        } else {
                            bounds.extend(place.geometry.location);
                        }
                    });
                    map.fitBounds(bounds);
                });


                window.google.maps.event.addListener(map, "click", function (e) {
                    latLng = e.latLng;
                    let values = "";
                    $.get('https://roads.googleapis.com/v1/snapToRoads', {
                        key: "AIzaSyAQ1krD63ufWzBQAATKmIRKBaDPOlXZfks",
                        path: e.latLng.lat() + ',' + e.latLng.lng() + '|' + (e.latLng.lat() + 0.0000000001) + ',' + (e.latLng.lng() + 0.0000000001)
                    }, function (data) {
                        values = new window.google.maps.LatLng(
                            data.snappedPoints[0].location.latitude,
                            data.snappedPoints[0].location.longitude
                        );
                    }).then(function () {
                        values = values.toString();
                        streetLat = values.substring(1, values.indexOf(','));
                        streetLng = values.substring(values.indexOf(', ') + 2, values.length - 1);

                        let geocoder = new window.google.maps.Geocoder();
                        let latLngObj = {
                            lat: e.latLng.lat(),
                            lng: e.latLng.lng()
                        };
                        geocoder.geocode({ location: latLngObj }, (results) => {
                            if (results[0]) {
                                inputAddress = results[0].formatted_address;
                            }
                        });



                        panoCoords = { lat: Number(streetLat), lng: Number(streetLng) };
                        if (marker && marker.setMap) {
                            marker.setMap(null);
                        }
                        marker = new window.google.maps.Marker({
                            position: latLng,
                            map: map
                        });
                        panorama = new window.google.maps.StreetViewPanorama(
                            document.getElementById("pano"),
                            {
                                position: panoCoords,
                                pov: {
                                    heading: 34,
                                    pitch: 10,
                                },
                            }
                        );
                        map.setStreetView(panorama);
                    }).then(function () {
                        panoHeading = panorama.getPov().heading;
                        panoPitch = panorama.getPov().pitch;
                        panorama.addListener("position_changed", () => {
                            streetLat = Number(panorama.getPosition().toString().substring(1, panorama.getPosition().toString().indexOf(',') - 1));
                            streetLng = Number(panorama.getPosition().toString().substring(panorama.getPosition().toString().indexOf(',') + 2, panorama.getPosition().toString().length - 1));
                            imageURL = "https://maps.googleapis.com/maps/api/streetview?size=350x350&location=" + streetLat + "," + streetLng + "&fov=80&heading=" + panoHeading + "&pitch=" + panoPitch + "&key=AIzaSyAQ1krD63ufWzBQAATKmIRKBaDPOlXZfks";
                        });
                        panorama.addListener("pov_changed", () => {
                            panoHeading = panorama.getPov().heading;
                            panoPitch = panorama.getPov().pitch;
                            $("#headings").html("Heading: " + panoHeading + "<br/>Pitch: " + panoPitch);
                            imageURL = "https://maps.googleapis.com/maps/api/streetview?size=350x350&location=" + streetLat + "," + streetLng + "&fov=80&heading=" + panoHeading + "&pitch=" + panoPitch + "&key=AIzaSyAQ1krD63ufWzBQAATKmIRKBaDPOlXZfks";
                        });
                    });

                });
            }, function () {
                //do nothing on error
            }, options);
        }
    }

    pictureTaken() {
        this.setState({ pictureTaken: true });
    }

    uploadImage() {
        db.ref('info').set({
            addressLine: inputAddress,
            lat: streetLat,
            lng: streetLng,
            imageURL: imageURL
        });
    }

    pointTaken() {
        this.setState({ pointTaken: true });
    }

    render() {


        return (
            <div>
                <div id="inputBox">
                    <input
                        id="pac-input"
                        className="controls"
                        type="text"
                        placeholder="Search Box"
                    />
                </div>
                <div id="maps" onClick={() => this.pointTaken()}></div>
                <p>Drop a pin on your preferred delivery location above.</p>

                <br />
                {
                    this.state.pointTaken ?
                        <div>
                            <div id="pano"></div>
                            <p>
                                <button className="savePic" onClick={() => this.pictureTaken()}>Save picture of your location</button>
                            </p>
                        </div>
                        : null
                }
                {
                    this.state.pictureTaken ?
                        <div>
                            <p>The vendor will receive the following information:</p>
                            <h4>Latitude, Longitude:</h4>
                            <p>({streetLat}, {streetLng})</p>
                            <h4>Image of your drop off location:</h4>
                            <img src={imageURL} alt="picTaken" />
                            <p><a href="/success"><button className="uploadPicture" onClick={() => this.uploadImage()}><b>Approve</b></button></a></p>
                        </div> : null
                }
                <br />
                <Route path="/success" exact component={Success} />
            </div>
        );
    }
}

export default OuterLocation;